import { graphql, StaticQuery } from 'gatsby';
import { FixedObject } from 'gatsby-image';
import React from 'react';
import { Logo } from '../Logo';

import { css } from '@emotion/react';

import config from '../../website-config';

interface SiteNavLogoProps {
  logo?: {
    childImageSharp: {
      fixed: FixedObject;
    };
  };
}

export const SubscribeLogo: React.FC<SubscribeProps> = props => {
  return (
    <Logo css={SubscribeOverlayLogo} className="subscribe-overlay-logo" />
  );
};

const SubscribeOverlayLogo = css`
  position: fixed;
  top: 23px;
  left: 30px;
  height: 30px;
  fill: #FFF;
`;

export default SubscribeLogo;
